export const HIGHEST_NUMBER = 99999999;

// Matrix dimensions
export const DEFAULT_MINIMUM_COLUMNS = 1;
export const DEFAULT_MAXIMUM_COLUMNS = 10;
export const DEFAULT_MINIMUM_TIERS = 1;
export const DEFAULT_MAXIMUM_TIERS = HIGHEST_NUMBER;

// Input limits - Percent
export const PERCENT_INPUT_TYPE = "Percent";
export const PERCENT_MIN = 0;
export const PERCENT_MAX = 100;
export const PERCENT_DECIMALS = 2;
export const PERCENT_DELTA = 0.01;

// Input limits - Unit
export const UNIT_INPUT_TYPE = "Unit";
export const UNIT_MIN = 0;
export const UNIT_MAX = HIGHEST_NUMBER;
export const UNIT_DECIMALS = 1;
export const UNIT_DELTA = 1;

// Input limits - Dollar/Bonus
export const DOLLAR_INPUT_TYPE = "Dollar";
export const DOLLAR_MIN = 0;
export const DOLLAR_MAX = HIGHEST_NUMBER;
export const DOLLAR_DECIMALS = 2;
export const DOLLAR_PER_UNIT_INPUT_TYPE = "Dollar per Unit";

export const SALES_POSITION = "Sales Associate";
export const SALES_ASSOCIATE_DELTA = 0.5;
export const MANAGER_POSITION = "F&I Manager";
export const MANAGER_DELTA = 1;
export const MANAGER_DECIMALS = 0;

// Layouts
export const INPUT_SX = { width: "95px" };
